define('views/modules/calendar/animated-session/exercise/lists/week-brief/week-exercise-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/modules/calendar/animated-session/exercise/weight/week-brief/weight-brief-content',
    'views/modules/calendar/animated-session/exercise/cardio/week-brief/cardio-brief-content',
    // parent view
    'views/modules/calendar/animated-session/exercise/lists/exercise-list-item',
    //services
    'services/toastr-service',
    // templates
    'text!templates/modules/calendar/animated-session/exercise/lists/week-brief/week-exercise-list-item.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VWeightBriefContent,
    VCardioBriefContent,
    // parent view
    VExerciseListItem,
    // services
    ToastrService,
    // templates
    TWeekExerciseListItem
) {

    var VWeekExerciseListItem = VExerciseListItem.extend({
        template: TWeekExerciseListItem,
        weightContentView: VWeightBriefContent,
        cardioContentView: VCardioBriefContent,

        events: _.extend(VExerciseListItem.prototype.events, {
            'click .exercise-box': 'onExerciseClick',
            'click .exercise-thumbnail': 'onExerciseThumbnailClick',
            'click .col-item-feedback': 'onDoneClick',
        }),

        onDoneClick: function(e) {
            if (!this.options.item.hasPassed()) {
                ToastrService.error('calendar:cannot-mark-future-items-as-done');
                return;
            }

            var model = this.model;
            if (model.isWeight()) {
                var week = this.getWeek();
                week.toggleDone(!week.isDone());
                model.trigger('change:done', week.isDone());

            } else {
                var weekIndex = this.options.item.getWeek();
                model.setCardioWeekDone(weekIndex);
                this.toggleDone(model.getWeekDone(weekIndex));
                model.trigger('change:done', model.getWeekDone(weekIndex));
                // TODO Passing the phase week in trigger function
                // model.trigger('change:done', week, week.isDone());
            }
        },

        onExerciseThumbnailClick: function(e) {
            this.onViewAnimationDetailsAction();
        },

        onExerciseClick: function(e) {
            var target = Backbone.$(e.target);
            if (target.is('.exercise-thumbnail,.col-item-feedback,.item-check,.options-toggle,.ucol-menu')) return;
            this.onEditAction();
        },

        onEditAction: function(e, actionModel) {
            var model = this.model.clone({ deep: true });
            model.set("oldCid", this.model.cid);
            this.model.trigger('exercise:edit', model);

            //this.model.trigger('exercise:edit', this.model);
        },

        onLinkClick: _.noop

    });

    return VWeekExerciseListItem;

});

